// copied from website-react/src/services/analytics/constants.ts

export const EVENTS = {
  OrderCompleted: 'Order Completed', // https://segment.com/docs/connections/spec/ecommerce/v2/#order-completed
  add_payment_info: 'AddPaymentInfo',
  CampaignExpired: 'CampaignExpired',
  ErrorMessageShown: 'ErrorMessageShown',
  ErrorMessageDuplicateEmail: 'ErrorMessageDuplicateEmail',
  CollapsiblePanelStateChanged: 'CollapsiblePanelStateChanged',
  QuestionnaireComplete: 'QuestionnaireComplete',
  InitiateQuoteSave: 'InitiateQuoteSave',
  ContactUs: 'ContactUs',
  WebPurchaseFailCreditScore: 'WebPurchaseFailCreditScore',
  DropdownItemClicked: 'DropdownItemClicked',
  QuickChoiceMenuClicked: 'QuickChoiceMenuClicked',
  OfferToExistingUser: 'OfferToExistingUser',
  ButtonPressed: 'ButtonPressed',
  AccordionListItemToggled: 'AccordionListItemToggled',
  ListItemClicked: 'ListItemClicked',
  PopupOpened: 'PopupOpened',
  PopupClosed: 'PopupClosed',
  PopupCTAPressed: 'PopupCTAPressed',
  CustomerDataPopulated: 'CustomerDataPopulated', // To trigger TrustPilot review invites: https://hellogetsafe.atlassian.net/browse/BFPC-734
  ExperimentStarted: '$experiment_started',
  UserLoggedIn: 'UserLoggedIn',
  ExtensionSwitchToggled: 'ExtensionSwitchToggled',
  InputEntered: 'InputEntered',
  ToggleSwitched: 'ToggleSwitched',

  // Add the tracking format event names for calendly
  MGABookingCalendlyPageOpened: 'MGABookingCalendlyPageOpened',
  MGABookingCalendlyDateAndTimeSelected: 'MGABookingCalendlyDateAndTimeSelected',
  MGABookingCalendlyAppointmentScheduled: 'MGABookingCalendlyAppointmentScheduled',

  // New tracking format event names
  CheckoutStarted: 'Checkout Started',
  CheckoutContinued: 'Checkout Continued',
  CheckoutStepViewed: 'Checkout Step Viewed',
  CheckoutStepCompleted: 'Checkout Step Completed',
  LeadGenerated: 'Lead Generated',
  ProductAdded: 'Product Added',
  ButtonClicked: 'Button Clicked',

  // Quote step interactions
  QuoteStepViewed: 'QuoteStepViewed',
  UserPriceChanged: 'UserPriceChanged',

  LegalConfirmationTitleToggled: 'Legal Confirmations Title Toggled',
  LegalConfirmationsCheckboxToggled: 'Legal Confirmations Checkbox Toggled',

  AppDownloadButtonClicked: 'AppDownloadButtonClicked',

  StepFailure: 'StepFailure',

  // OTPLogin
  InvalidOtpCode: 'InvalidOtpCode',
  ValidOtpCode: 'ValidOtpCode',

  // Editable Summary tracking
  RedirectToQuoteStep: 'RedirectToQuoteStep',

  TravelHealthCompleted: 'TravelHealthCompleted',

  // Invalid Permanent discount
  PermanentDiscountInvalid: 'Permanent Discount Invalid',

  // Coupon code validated at the payment step
  CouponCodeValidated: 'Coupon Code Validated',

  // Dental retargeting events
  QuoteEmailSubmitted: 'Quote Email Submitted',
  QuotePhoneSubmitted: 'Quote Phone Submitted',
  ContactDetailsSubmitted: 'Contact Details Submitted',
}

export const EVENTS_CATEGORIES = {
  checkout: 'Checkout',
}

export const EVENTS_LABELS = {
  overview: 'FirstProductionCart',
  payment: 'Payment-Methods',
  purchase: 'First Product In Cart',
}

export const COLLAPSIBLE_PANEL_IDS = {
  storybookPanel: 'storybookPanel',
  summaryScreen: 'summaryScreen',
  summaryStepProductBenefits: 'summaryStepProductBenefits',
  coInsuredSummary: 'coInsuredSummary',
  extensionSummary: 'extensionSummary',
  quoteStepCoverageDetails: 'quoteStepCoverageDetails',
  harmonyQuoteStepDocuments: 'harmonyQuoteStepDocuments',
  harmonyQuoteStepCoverageSelector: 'harmonyQuoteStepCoverageSelector',
} as const

export const BUTTON_IDS = {
  CalendlyScheduleAppointment: 'calendlyScheduleAppointment',
  listAddButton: 'listAddButton',
  listEditButton: 'listEditButton',
  removeEditableSetItem: 'removeEditableSetItem',
  addEditableSetItem: 'addEditableSetItem',
} as const
